export default __webpack_public_path__ + "static/media/dragon-fly-insect-animal-shape.d1565e73.svg";